import { MDBAlert, MDBBtn, MDBCheckbox, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBSelect, MDBSpinner, MDBTooltip } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CircleCheck from "../../../components/images/circleCheck.svg";
import AddIPAddress from '../../popups/securitymanager/AddIPAddress';
import PopupLoaderNew from '../../popups/PopupLoaderNew';
import DeleteIPAddress from '../../popups/securitymanager/DeleteIPAddress';
import { getAllSecurityDesktopInfo } from '../../../apiclients/streamsapi_bridge';
import { useNavigate } from 'react-router';
import TopSuccess from '../../../components/header/TopSuccess';
import TopMessage from '../../../components/header/TopMessage';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../../components/CustomSearchUtil/CustomSearch';
import UIConstant from '../../../apiclients/UIConstant';
import TabIDConstant from '../../../apiclients/TabIDConstant';

function TrustedIPAddressRange({ isActive }) {
    const { t, i18n } = useTranslation();
    const [centredModal, setCentredModal] = useState(false);
    const [deleteip, setdeleteip] = useState(false);
    const [trustedipList, settrustedipList] = useState([]);
    const addUserRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const toggledelete = () => setdeleteip(!deleteip);
    const [ipid, setipid] = useState({});
    const [isloading, setIsloading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [internalError, setInternalError] = useState("");
    const [rerender, setRerender] = useState(false);
    const [rowsData, setRowsData] = useState([]);
    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    const navigate = useNavigate();
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)

    function handleClick() {
        addUserRef.current.click();
    }
    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    const toggleOpen = () => setCentredModal(!centredModal);

    async function fetchData() {
        const response = await getAllSecurityDesktopInfo(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            TabIDConstant.TRUSTED_IP_SUBLINK
        );
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const rawData = await response.json();
        if (!rawData) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("response data is :::::::::: " + JSON.stringify(rawData));
        // setAssignedNumbers(rawData?.ph_numbers?.assigned_phnum ?? []);

        settrustedipList(rawData?.ip_Details ?? []);
        // setpendingUsers(rawData?.pending_Users ?? []);
        // setauthorixedUser(rawData?.authorized_Users ?? []);
        // setblockedUsers(rawData?.blocked_Users ?? []);
        // setdevicesToTrust(rawData?.devices_to_Trust ?? []);
        // settrustedDevices(rawData?.trusted_Devices ?? []);

    }


    useEffect(() => {
        if (isActive || rerender) {
            fetchData();
            setRerender(false);
        }
    }, [isActive, rerender]);

    // useEffect(() => {
    //     if (props.trustedIPS && props.trustedIPS.length > 0) {
    //         settrustedipList(props.trustedIPS);
    //     }

    // }, [props.trustedIPS]);

    const handleIPAddressDelete = (e, ipsInfo) => {
        e.preventDefault();
        const ips = ipsInfo.ip_address;
        const ipInfo = {
            ip_address: ips.split("/")[0].trim(),
            range: ips.split("/")[1].trim()
        }
        setipid(ipInfo);
        toggledelete();
    }

    useEffect(() => {
    let processdrows = [];
    trustedipList.map((ips) => {
        processdrows.push({
            trustedIpInfo: { ...ips },
            name: ips.ip_address,
            addedon: ips.added_on,
            action: (<MDBIcon fas icon="times" onClick={(e) => handleIPAddressDelete(e, ips)} color="primary" />)
        })
    })
    setFilteredRows(processdrows)
    setRowsData(processdrows)
    setDataLoaded(true)
    },[trustedipList,isActive])



    const actionData4 = {
        columns: [
            { label: 'IP Address', field: 'name' },
            { label: 'Added On', field: 'addedon' },
            { label: 'Action', field: 'action', sort: false },
        ],
        rows: rowsData
    };


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowsData, searchValue, UIConstant.TRUSTEDIP_LANDING);

        setFilteredRows(filteredUsers);
    };

    //     [
    //         {
    //             name: '171.61.129.*',
    //             position: 'October-25-2022 23:00:17',
    //             contact: (<MDBIcon fas icon="times" color="primary" />)
    //         },
    //         {
    //             name: '183.82.126.*',
    //             position: 'January-04-2023 17:07:17',
    //             contact: (<MDBIcon fas icon="times" color="primary" />)
    //         },
    //         {
    //             name: '202.65.142.*',
    //             position: 'October-25-2022 23:03:01',
    //             contact: (<MDBIcon fas icon="times" color="primary" />)
    //         },
    //         {
    //             name: '202.65.142.*',
    //             position: 'October-25-2022 23:03:01',
    //             contact:
    //                 (
    //                     <>
    //                         <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title="Activate device">
    //                             <img src={CircleCheck} className="w_20px" />
    //                         </MDBTooltip>
    //                     </>
    //                 )
    //         },
    //     ]
    // };
    return (
        <>
            <div className="d-flex align-items-center justify-content-between actionbar">
                {/* <h5>{t('AccountTrustedIpAddress')}</h5> */}
                <MDBBtn className="float-end" onClick={toggleOpen} > {t("addIp")}</MDBBtn>
            </div>
            <div className='mb-2 position-relative w-auto'>
                <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <div className="SecutityTopViewPage1">
                <MDBDatatable hover key={searchValue}
                data={{...actionData4,
                    rows:filteredRows
                }}
                sortField="IP Address" className='actioncolumnbig'  entries={50} />
            </div>



            {centredModal && (
                <PopupLoaderNew
                    title={"Add IP Address"}
                    content={<AddIPAddress onClose={toggleOpen}
                        ref={addUserRef}
                        setIsloading={setisLoading}
                        setSuccessMessage={setSuccessMessage}
                        setRerender={setRerender}
                    />}
                    onShow={setCentredModal}
                    onClose={toggleOpen}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}

            {deleteip && (
                <PopupLoaderNew
                    title={"Remove IP Address"}
                    content={<DeleteIPAddress
                        id={ipid}
                        onClose={toggledelete}
                        ref={addUserRef}
                        setIsloading={setisLoading}
                        setSuccessMessage={setSuccessMessage}
                        setRerender={setRerender}
                        setInternalError={setInternalError}
                    />}
                    onShow={setdeleteip}
                    onClose={toggledelete}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            {successMessage && (
                <>
                    <TopSuccess>
                        <TopMessage successMessage={successMessage} />
                    </TopSuccess>
                </>
            )}



            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
                onClose={() => setInternalError("")}
            >Internal Server Error</MDBAlert>)}

        </>
    )
}

export default TrustedIPAddressRange
